import React from "react";

import { FieldFolder } from "@keepeek/refront-components";
import { Widget, WidgetProps } from "@rjsf/utils";
import { useTranslation } from "react-i18next";

import { KIcon } from "../../../../components/common/KIcon";

const CustomFolderWidget: Widget = function ({ onChange, value, ...props }: WidgetProps) {
  const { t } = useTranslation();
  return (
    <FieldFolder
      helperText={t("admin:components.mosaicElement.folder.description")}
      title={t("admin:folderSelectWidget.title")}
      label={props.label}
      forceSelection={true}
      multiple={false}
      onChange={(values) => onChange(values && values.length > 0 ? values[0] : null)}
      initialFolderIds={[value]}
      KIcon={KIcon}
    />
  );
};

export default CustomFolderWidget;
